import { jsxs, jsx } from "react/jsx-runtime";
const IconExperienceSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m22.832 8.445-4-6A1 1 0 0 0 18 2H6a1 1 0 0 0-.832.445l-4 6a1 1 0 0 0 .063 1.196l10 12c.01.01.025.015.034.026a.984.984 0 0 0 .231.177c.034.02.06.05.097.065A.99.99 0 0 0 12 22a.99.99 0 0 0 .407-.09c.036-.017.063-.045.097-.065a.985.985 0 0 0 .23-.178c.01-.01.025-.015.035-.026l10-12a1 1 0 0 0 .063-1.196ZM20.132 8H16.72l-1.333-4h2.078l2.667 4ZM13.28 4l1.333 4H9.387l1.333-4h2.56ZM11 10v8.238L4.135 10H11Zm2 0h6.865L13 18.238V10ZM6.535 4h2.078L7.28 8H3.868l2.667-4Z" })
    ]
  }
);
export {
  IconExperienceSvg
};
